import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../constants';
import { clsx } from '../../utils';

export type StyleKey = keyof ReturnType<typeof checkoutFormStyles>;

export const checkoutFormStyles = (theme?: Theme, sx?: Partial<Record<string, SxProps<Theme>>>) => ({
	root: clsx(
		{
			display: 'flex',
			flexDirection: { xs: 'column', md: 'row' },
			alignItems: { xs: 'center', md: 'stretch' },
			justifyContent: { xs: 'flex-start', md: 'center' },
			gap: '16px',
			overflow: { xs: 'auto', md: 'hidden' },
		},
		sx?.['root']
	),
	detailsLeft: clsx(
		{
			display: 'flex',
			flexDirection: 'column',
			maxWidth: '320px',
		},
		sx?.['detailsLeft']
	),
	detailsHeader: clsx(
		{
			display: 'flex',
			flexDirection: 'row',
			gap: '12px',
			alignItems: 'center',
			padding: '24px',
			backgroundColor: Colors.black_a40,
			borderRadius: '8px 8px 0px 0px',
			position: 'relative',

			'&:before': {
				content: '""',
				position: 'absolute',
				inset: 0,
				borderRadius: '8px 8px 0 0',
				border: '2px solid transparent',
				borderBottom: 'none',
				background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 91.05%) border-box',
				mask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
				maskComposite: 'exclude',
				pointerEvents: 'none',
			},
		},
		sx?.['detailsHeader']
	),
	detailsSummary: clsx(
		{
			display: 'flex',
			flexDirection: 'column',
			gap: '18px',
			padding: '24px',
			backgroundColor: Colors.black_a30,
			borderRadius: '0 0 8px 8px',
		},
		sx?.['detailsSummary']
	),
	formRight: clsx(
		{
			minWidth: { xs: '100%', md: '620px' },
			maxWidth: { xs: '100%', md: '620px' },
			flexGrow: { xs: 'unset', md: '1' },
			borderRadius: '8px',
			py: '24px',
			px: '24px',
			backgroundColor: Colors.black_a50,
			display: 'flex',
			flexDirection: 'column',
			gap: '24px',
			overflow: { xs: 'unset', md: 'auto' }
		},
		sx?.['formRight']
	),
	formContent: clsx(
		{
			display: 'flex',
			flexDirection: 'column',
			gap: '12px',
		},
		sx?.['formContent']
	),
});
